query CollectionTypeShow($id: ID!) {
  collectionType(id: $id) {
    id
    title
    platformId
    organizationId
    showInSearch
    collectionDisplayMode
    createdAt
    updatedAt
    deletedAt
    deleted
  }
}
